import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AssinaturaStore } from "../../stores/assinatura/AssinaturaStore";
import { MonthPicker } from "../utils/MonthPicker";
import moment from "moment";
import { toast } from "react-toastify";
import { PerfilStore } from "../../stores/perfil/PerfilStore";

interface DataVencimentoPageProps {
}

interface DataVencimentoPageState {
}

@observer
export default class DataVencimento extends React.Component<DataVencimentoPageProps, DataVencimentoPageState> {

  constructor(props) {
    super(props);
  }

  async handleChangeDataPagamento() {

    let data_vencimento = moment(PerfilStore.obs.expires_at).format("YYYY-MM-DD");

    if (!data_vencimento || data_vencimento == "Data inválida") {

      toast.warning('Selecione uma data valida.', {});
      return
    }

    await AssinaturaStore.handleAlteraDataVencimento(data_vencimento);

  }

  handleDateChange = (val: Date) => {

    if (val == null) {

      return PerfilStore.obs.expires_at = null

    }

    var date1 = moment(val).format("YYYY-MM-DD");

    var dataAgora = moment().add('day', 5).format("YYYY-MM-DD");

    if (date1 < dataAgora) {

      toast.warning('Selecione uma data posterior a 5 dias a partir de hoje.', {});
      return PerfilStore.obs.expires_at = null

    } else {

      return PerfilStore.obs.expires_at = val

    }

  };

  render() {
    return (
      <>
        <h3 className="titleProccess">Digite uma Data de Vencimento:</h3>

        <MDBRow>
          <MDBCol md="4">
            <MonthPicker
              onChange={(e) => this.handleDateChange(e)}
              value={PerfilStore.obs.expires_at}
            />
          </MDBCol>

          <MDBBtn
            className="btnDefault"
            onClick={(e) => this.handleChangeDataPagamento()}
          >
            Salvar
          </MDBBtn>
        </MDBRow>
      </>
    );
  }
}
